/** Midnight today, local time. */
export function startOfToday(): Date {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
}

/** Midnight tomorrow, local time — pairs with `startOfToday()` as an
 * exclusive `[from, to)` range for "today". */
export function endOfToday(): Date {
  const d = startOfToday();
  d.setDate(d.getDate() + 1);
  return d;
}
